import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { LandingPage } from "@/pages/web/landings/kit/LandingPage";
import { homeConfig } from "./homeContent";
/**
 * Главная «/» для неавторизованного — такой же публичный лендинг, как
 * SEO-страницы: тот же кит (шапка с якорями, секции, футер с перелинковкой,
 * липкий мобильный CTA, JSON-LD с FAQPage) и тот же контракт пререндера.
 * Контент — в homeContent.ts.
 *
 * Имя компонента сторожит prerenderInfra.test.ts: App.tsx обязан рендерить его
 * в ветке `homeLandingStandalone` (вне app-shell, с data-prerender-standalone).
 */
export const WelcomePage = () => (_jsx(LandingPage, { config: homeConfig }));
